export enum GoalState {
  Draft = 0,
  ToManager = 1,
  Agreed = 2,
  ReviewEmployee = 3,
  ReviewManager = 4,
  EvaluationDiscussion = 6,
  Finished = 7,
  OpenForCalibration = 8,
  Calibrated = 9,
  Canceled = 10,
  ReviewEmployeeManager = 11,
}

export enum FeedbackType {
  Allstar = 3,
}

export enum RatingType {
  Person,
  Supervisor,
  Calibrated,
}

export enum GoalActivityListItemType {
  None,
  Comment = 1,
  Milestone = 2,
  Feedback = 4,
  All = 255,
}

export enum GoalPriority {
  Low,
  Medium,
  High,
}

export enum GoalKind {
  Normal = 0,
  WithMetric = 1,
  NewGoal = 2,
  NewGoalWithMetric = 3,
  RequiredByOrganization = 4,
}

export enum GoalType {
  PerformanceGoal,
  TeamGoal,
  DevelopmentGoal,
}

export enum CommentVisibility {
  User = 1,
  Author = 4,
  Supervisor = 8,
}

export enum CommentType {
  Self,
  Colleague,
  Supervisor,
  Generated, // change state of goal
}

export enum CommentDataType {
  None,
  GoalStatusChange,
  GoalContentUpdate,
}

export enum DevelopmentGoalDuration {
  ShortTerm = 1,
  LongTerm = 3,
}

export enum DevelopmentGoalState {
  Draft,
  ToManager,
  Agreed,
  ReviewEmployee,
  ReviewManager,
  Completed = 7,
  NotCompleted = 8,
}

export enum ReviewType {
  MidYear = 0,
  EndYear = 1,
  OneToOne = 2,
  Probation = 3,
  LeaveCompany = 5,
  ChangePosition = 6,
  Exit = 7,
  MidYearNew = 8,
  EndYearNew = 9,
}

export const AssessmentQuestionSection = {
  TellUs: 1,
  Aspiration: 2,
}

export enum ChatBotMessageType {
  Question,
  Answer,
}

export enum OrganizationUnits {
  Embedit = 2,
  HQ = 3,
  AB = 6,
  CZSK = 7,
  BY = 8,
  KZ = 9,
  RU = 10,
  CN = 11,
  IN = 12,
  INDS = 13,
  VN = 14,
  PHI = 15,
  US = 16,
  Zonky = 18,
  INAB = 19,
  ABDE = 20,
  MyDok = 21,
}

export enum CountryCode {
  cz = 'cz',
  svk = 'svk',
  cn = 'cn',
  phi = 'ph',
  kz = 'kz',
  ru = 'ru',
  inds = 'inds',
  in = 'in',
  vn = 'vn',
  us = 'us',
}



// WEBPACK FOOTER //
// ./src/app/front-face/models/enums.ts